import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type IntroBodyProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

function IntroBody({children, sx}: IntroBodyProps) {
    return (
        <Typography sx={{
            fontWeight: '400',
            fontFamily: 'Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '20px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '20px',
                lineHeight: 1.6,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '18px',
                lineHeight: 1.56,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '18px',
                lineHeight: 1.6,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '14px',
                lineHeight: 1.57,
            },
            '@media screen and (max-width: 575px)': {
                fontSize: '16px',
                lineHeight: 1.6,
                alignItems: 'flex-start',
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                fontSize: '16px',
                lineHeight: 1.63,
            },
            ...sx
        }}>
            {typografNode(children)}
        </Typography>
    );
}

export default IntroBody
